import axios from 'axios';
import { notification, Modal } from 'antd';
import 'antd/lib/modal/style/index.css';
import NProgress from 'nprogress';
import Qs from 'qs';
import 'nprogress/nprogress.css';
import './index.less';
import clearCookie from 'utils/clearCookie';
import { getStationID, setCookie } from '@/utils/cookie';
import { useRequest } from 'ahooks';

const isPHPInterface = (targetUrl) => targetUrl.indexOf('/ui/manage') !== -1;

/**
 * 判断是否是模块迁移过的新java接口
 * @param {string} url
 */
const isNewJavaUrl = (url) =>
  [
    '/operation/smart/station', // 仓库管理
    '/smart/web/account', // 账号管理
    '/smart/web/auth', // 权限集、权限点管理
    '/smart/web/customerGroup', // 货主组管理
    '/smart/web/sku', // 产品档案管理
    '/operation/smart/common/getimporttpl', // 获取模板（公共接口）
  ].some((prefix) => url.includes(prefix));

// const interceptorObj = {}; // 将刚请求url以 时间戳：url 的形式存储
let hasError = false; // 判断返回的结果有无错误
let timer = null; // 设置定时器
// axios.defaults.baseURL = '/smart/api';
axios.defaults.withCredentials = true;

// 响应拦截器（异常处理）
axios.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      const { data } = response;
      const { errno, errmsg = '', result = {} } = data;

      if (errno === 0) {
        return Promise.resolve(result);
      }
      // 计件编组校验未通过
      if (errno === 20000) {
        return Promise.resolve({
          ...result,
          errmsg,
          errno,
        });
      }
      // 未登录
      if (errno === 110003 || errno === 2000006) {
        const msg = '您尚未登录，请先登录！';
        setCookie('SMARTTOKEN', '', -1);
        window.location.replace('/login');
        return Promise.reject(msg);
      }
      // 无权限
      if (errno === 110008) {
        const msg = '该用户没有此操作权限';
        window.location.replace('/noAuth');
        return Promise.reject(msg);
      }
      if (errno === 110013) {
        // eslint-disable-next-line
        return Promise.reject({ errno, errmsg });
      }
      if (errno === 110004) {
        clearCookie();
      }
      return Promise.reject(errmsg);
    }
    return Promise.resolve(response);
  },
  (err) => {
    // 拦截掉的请求
    if (axios.isCancel(err)) {
      return Promise.reject(err.message);
    }
    // 其他异常请求
    let errmsg = '网速慢或网络连接异常，请检查网络后刷新系统！';
    if (err && err.response) {
      errmsg = `${err.response.status} ${err.response.statusText}`;
    }
    return Promise.reject(errmsg);
  },
);

export function $http({ method = 'get', url, params, isForm = false }) {
  const config = {
    method,
    url: isPHPInterface(url) ? '/smart/api' + url : url,
    timeout: 30000,
  };

  if (!isForm) {
    // 获取localstorage中的op_station_id
    const op_station_id = getStationID('op_station_id');
    if (op_station_id)
      if (isPHPInterface(url)) {
        params.op_station_id = op_station_id;
      } else if (!isNewJavaUrl(url)) {
        // 由php迁移到java的新接口，当前站点参数后端会直接从cookie中取，不需要前端传了，所以需要剔除，否则会影响部分接口使用stationId这个参数
        // 之前部分老java接口还需要前端传stationId作为当前站点，目前只能这么处理
        params.stationId = op_station_id;
      }
    // 非表单提交
    if (method === 'get') {
      config.params = params || '';
    }
    if (method === 'post') {
      config.headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
      config.data = Qs.stringify(params || {});
    }
    if (method === 'postJSON') {
      config.method = 'post';
      config.headers = { 'Content-Type': 'application/json' };
      config.data = JSON.stringify(params || {});
    }
  } else {
    // 表单提交参数为formData
    config.data = params;
  }
  NProgress.start();
  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        resolve(res);
        NProgress.done();
      })
      .catch((err) => {
        NProgress.done();
        if (!hasError) {
          if (err.errno === 110013) {
            Modal.error({
              title: err.errmsg,
              content: '',
              keyboard: false,
              className: 'station-disable-modal',
              onOk() {
                window.location.replace('/login');
              },
            });
          } else {
            notification.error({
              message: '请求错误',
              description: err,
            });
          }
        }
        // 错误节流 避免多次错误提示
        hasError = true;
        clearTimeout(timer);
        timer = setTimeout(() => {
          hasError = false;
        }, 1000);
        reject(err);
      });
  });
}

export const $get = ({ url, params }) => $http({ url, params });
export const $post = ({ url, params, isForm = false }) =>
  $http({ method: 'post', url, params, isForm });

export const useHttp = (service, params) => {
  const result = useRequest(service, {
    ...params,
    requestMethod: (data) => $http(data),
  });
  return result;
};
export const $postJSON = ({ url, params, isForm = false }) =>
  $http({ method: 'postJSON', url, params, isForm });
